import { z } from 'zod'

// Search input schema
export const searchInputSchema = z.object({
  query: z.string().min(1),
  limit: z.number().optional().default(16),
})

export type SearchInput = z.infer<typeof searchInputSchema>

// Customer search result
export const customerSearchResultSchema = z.object({
  type: z.literal('customer'),
  id: z.number(),
  displayName: z.string(),
  customerType: z.string(),
  status: z.string(), // Customer status (active, paused, churned)
  propertiesCount: z.number().optional(),
  email: z.string().optional(),
  phoneNumber: z.string().optional(),
})

export type CustomerSearchResult = z.infer<typeof customerSearchResultSchema>

// Property search result
export const propertySearchResultSchema = z.object({
  type: z.literal('property'),
  id: z.number(),
  displayName: z.string(), // Street address
  propertyType: z.string(),
  customerId: z.number().optional(),
  customerName: z.string().optional(),
  subscriptionInfo: z.string().optional(), // e.g., "Perus 150€/kk"
})

export type PropertySearchResult = z.infer<typeof propertySearchResultSchema>

// Opportunity search result
export const opportunitySearchResultSchema = z.object({
  type: z.literal('opportunity'),
  id: z.number(),
  displayName: z.string(),
  stage: z.string(), // Opportunity stage (required)
  email: z.string().optional(),
  phoneNumber: z.string().optional(),
})

export type OpportunitySearchResult = z.infer<
  typeof opportunitySearchResultSchema
>

// Discriminated union of all search result types
export const searchResultSchema = z.discriminatedUnion('type', [
  customerSearchResultSchema,
  propertySearchResultSchema,
  opportunitySearchResultSchema,
])

export type SearchResult = z.infer<typeof searchResultSchema>

// Grouped search response
export const searchResponseSchema = z.object({
  customers: z.array(customerSearchResultSchema),
  properties: z.array(propertySearchResultSchema),
  opportunities: z.array(opportunitySearchResultSchema),
})

export type SearchResponse = z.infer<typeof searchResponseSchema>
